/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { PlatformList } from '@/components/PlatformList'
import { TPlatformListService } from '@/components/PlatformList/interface'
import { LayoutOthers } from '@/layouts/LayoutOthers'
import { accountClient } from '@/services/cloudClient/accountClient'
import { ReloadOutlined } from '@ant-design/icons'
import { Button, Space, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import './styles.less'
import { usePrivateOffersColumns } from './usePrivateOffersColumns'

export function PrivateOffers() {
  const { t } = useTranslation()
  const { contractId } = useParams<{ contractId: string }>()

  if (!contractId) {
    throw new Error('Contract ID is required')
  }
  const columns = usePrivateOffersColumns()
  const emitter = PlatformList.useCreateEmitter()

  const handleRefresh = () => {
    emitter.fire({}, true)
  }

  const service: TPlatformListService = async ({ pagination }, options) => {
    // 确保pageSize有合理的默认值
    const pageSize = pagination?.pageSize || 10
    const current = pagination?.current || 1

    console.log('Fetching private offers for contract:', contractId, 'page:', current, 'pageSize:', pageSize)
    const response = await accountClient.privateOffersApi.apiV1ContractsIdPrivateOffersGet(
      contractId,
      current,
      pageSize
    )

    console.log('Private offers response:', response)

    // Filter out sensitive internal employee information for customer-facing API
    const filteredOffers = (response.data.privateOffers || []).map((offer: any) => {
      const {
        approverId,
        approverName,
        approvedAt,
        approvalComment,
        creatorName,  // 移除创建者姓名
        creatorId,    // 移除创建者ID
        ...filteredOffer
      } = offer
      return filteredOffer
    })

    // Ensure correct data format
    const result = {
      data: {
        items: filteredOffers,
        total: response.data.paginator?.totalSize || 0,
        page: current,
        pageSize: pageSize,
      }
    }

    console.log('Formatted result:', result)
    return result
  }

  return (
    <div className="private-offer-container">
      <LayoutOthers.MainContent title={t('Private Offers')}>
        <LayoutOthers.Alert className="margin-bottom-20">
          <div>· {t('private_offer_desc_1')}</div>
        </LayoutOthers.Alert>

        <LayoutOthers.ContentCard
          title={
            <Space>
              <span>{t('Available Offers')}</span>
              <Tooltip title={t('Refresh')}>
                <Button
                  type="text"
                  icon={<ReloadOutlined />}
                  onClick={handleRefresh}
                  size="small"
                  style={{ color: 'var(--ant-color-text-base)' }}
                />
              </Tooltip>
            </Space>
          }
          isTable
        >
          <PlatformList
            emitter={emitter}
            service={service}
            defaultTablePageSize={10}
            columns={columns}
            rowSelection={undefined}
          />
        </LayoutOthers.ContentCard>
      </LayoutOthers.MainContent>
    </div>
  )
}